module.exports = __webpack_public_path__ + "static/media/support-placeholder.774016b3.webp";